module.exports = __webpack_public_path__ + "img/avatar-4.140fa407.jpg";